<template>
<div class="ticket-message">
    <header v-if="message.kolkinid != ''">
		<b>{{message.first_name}} {{message.last_name}}</b>
		<time>{{message.creation | detailed_date}}</time>
    </header>
    <header v-else>

		<i class="icon icon-kolkin"></i>&nbsp;Kolkin
		<time>{{message.creation | detailed_date}}</time>
    </header>
    <div class="tiptap-content" v-html="message.message_html"></div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import AvatarText from "@/mixins/AvatarText";

export default {
    name: "TicketMessage",

    mixins: [
        AvatarText
    ],

    props: {
        message: {}
    },
}
</script>
